import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const Header = ({ goBack, step, isDisabled = false, title = 'Pay today with your card' }) => {
  if (step === 'saved-cards')
    return (
      <div className="flex flex-wrap items-center gap-1">
        <Typography variant="label" color="neutral-800" weight="semibold" size="medium">
          {title}
        </Typography>
      </div>
    );

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        icon="arrow-left-linear"
        variant="link"
        color="neutral"
        isDisabled={isDisabled}
        onClick={goBack}
        aria-label="Go back"
      />
      <Typography variant="label" color="neutral-600" weight="medium" size="medium">
        {title}
      </Typography>
      <Typography variant="label" color="neutral-800" weight="medium" size="medium">
        / Enter card manually
      </Typography>
    </div>
  );
};

export default Header;
